<template>
  <div>
    <router-link
      class="btn-unstyled font-weight-bold pt-3 pb-3 text-nowrap"
      :to="`/campaigns/${campaignId}/${name.toLowerCase()}`"
    >
      <svg-icon
        :icon="`${name.toLowerCase().replace(/\s/g, '')}-round`"
        class="icon-2x align-middle mr-2"
      />
      <span class="align-middle text-uppercase">{{ name | capitalize }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  font-size: 14px;
}
a {
  color: $body-color;
  text-decoration: none;
}
</style>
